import { FormArray, UntypedFormArray } from '@angular/forms';
import { Data } from '../models/data';

/**
 * Table Section validations functions
 */
export class TableSectionValidation {
  /**
   * Returns invalidArrayEntry error whether at least one entry in a FormArray like control is invalid or not
   * @param ctrl
   * @returns
   */
  public static invalidEntry(ctrl: UntypedFormArray | FormArray<any>): Data | null {
    return ctrl.controls.some(c => c.invalid) ? { invalidArrayEntry: true } : null;
  }
}
